<style>
.van-tabs--line .van-tabs__wrap{height: 88px}
.van-tabs__wrap--scrollable .van-tab{margin:0px 10px}
.van-tabs__content--animated{background: linear-gradient( 153deg, #EBF3FD 0%, #F4F8FC 100%);box-shadow: 0px 0px 4px 1px rgba(10,63,190,0.16);border-radius: 3px;border: 1px solid #FFFFFF;}
</style>
<template>
  <div class="home">
    <!-- Header -->
    <PhoneHeader @openForm="handleMenu"></PhoneHeader>
    <div class="banner-box">
      <div class="banner-con">
        <!--banner-->
        <div class="banner-title">轻骑兵<div style="font-size: 13px;vertical-align: super;line-height: 27px">®</div>零代码开发平台</div>
        <div class="banner-desc">人人都是开发者</div>
        <div class="app-button-div">
          <img class="app-button-img" src="../assets/img/zeroCodePhone/app-button-bg.png" @click="handleOpenPractice"/>
        </div>
        <!--轻骑兵 零代码开发平台-->
        <div class="div-title">轻骑兵<div style="font-size: 13px;vertical-align: super;line-height: 27px">®</div>零代码开发平台</div>
        <div class="div-desc">更敏捷的企业数字化转型支撑工具</div>
        <div class="base-content-div">
          <div>
            <div class="base-content-title">快速上线</div>
            <div class="base-content-desc">零代码简化了系统开发过程，使用零代码平台搭建应用系统，可以提高5-10倍的效率，缩短上线周期。</div>
          </div>
          <div>
            <img src="../assets/img/zeroCodePhone/base-img1.png"/>
          </div>
        </div>
        <div class="base-content-div">
          <div>
            <div class="base-content-title">更低成本</div>
            <div class="base-content-desc">无需专业的开发团队，可以省去人工开发的成本，系统上线周期缩短，相关系统实施成本也会大幅下降。</div>
          </div>
          <div>
            <img src="../assets/img/zeroCodePhone/base-img2.png"/>
          </div>
        </div>
        <div class="base-content-div">
          <div>
            <div class="base-content-title">敏捷迭代</div>
            <div class="base-content-desc">通过零代码平台调整原有业务，几分钟内即可完成系统更新；开展新业务，几个小时就能完成系统搭建，有效提高开发效率。</div>
          </div>
          <div>
            <img src="../assets/img/zeroCodePhone/base-img3.png"/>
          </div>
        </div>
        <div class="base-content-div">
          <div>
            <div class="base-content-title">自主可控</div>
            <div class="base-content-desc">企业完全掌握应用业务数据， 拥有国家级信息安全和权威认证，保障服务稳定和数据安全，能有效保证业务隐私性。</div>
          </div>
          <div>
            <img src="../assets/img/zeroCodePhone/base-img4.png"/>
          </div>
        </div>
        <!--轻骑兵 零代码开发平台 让您的想法更快地变为现实-->
        <div class="div-title">轻骑兵<div style="font-size: 13px;vertical-align: super;line-height: 27px">®</div>零代码开发平台</div>
        <div class="div-title" style="margin-top: -15px">让您的想法更快地变为现实</div>
        <div class="div-desc">无需编写代码，极速搭建应用程序</div>
        <div class="digitalize">
          <div class="digitalize-bg">
            <img src="../assets/img/zeroCodePhone/digitalize.png" />
          </div>
        </div>
        <!--轻骑兵 零代码开发平台 引领未来应用开发的新范式-->
        <div class="new-style">
          <div class="div-title" style="color: #fff;">轻骑兵<div style="font-size: 13px;vertical-align: super;line-height: 27px">®</div>零代码开发平台</div>
          <div class="div-title" style="margin-top: -15px;color: #fff">引领未来应用开发的新范式</div>
          <div class="div-desc" style="color: #fff">不只是平台，更是创新的启航点</div>
          <div class="new-style-div">
            <div class="new-style-list">
              <div>
                <img src="../assets/img/zeroCodePhone/new-style1.png">
              </div>
              <div class="new-style-title">表单设计器</div>
            </div>
            <div class="new-style-list">
              <div>
                <img src="../assets/img/zeroCodePhone/new-style1.png">
              </div>
              <div class="new-style-title">流程设计器</div>
            </div>
          </div>
          <div class="new-style-div">
            <div class="new-style-list">
              <div>
                <img src="../assets/img/zeroCodePhone/new-style1.png">
              </div>
              <div class="new-style-title">数据表格</div>
            </div>
            <div class="new-style-list">
              <div>
                <img src="../assets/img/zeroCodePhone/new-style1.png">
              </div>
              <div class="new-style-title">数据权限</div>
            </div>
          </div>
          <div class="new-style-div">
            <div class="new-style-list">
              <div>
                <img src="../assets/img/zeroCodePhone/new-style1.png">
              </div>
              <div class="new-style-title">仪表盘</div>
            </div>
            <div class="new-style-list">
              <div>
                <img src="../assets/img/zeroCodePhone/new-style1.png">
              </div>
              <div class="new-style-title">API连接</div>
            </div>
          </div>
        </div>
        <!-- 主要功能 -->
        <div class="main-method">
          <div class="div-title">主要功能</div>
          <van-tabs
            v-model="mainActive"
            animated
            swipeable
            duration="0.5"
            line-width="80px"
            line-height="2px"
            title-active-color="#186CF5"
            color="#186CF5"
            style="z-index: 5"
          >
            <van-tab name="first">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/zeroCodePhone/tab1.png"></div>
                表单设计器
              </div>
              <div class="main-tabs-tabItem"><img src="../assets/img/zeroCode/tab1.png" /></div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>通过可视化拖拽+快速配置的方式快速搭建应用系统，一次开发多端适配，支持适配不同分辨率，也支持多段式布局，开发的页面可以实时预览，所见即所得。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="second">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/zeroCodePhone/tab2.png"></div>
                流程设计器
              </div>
              <div class="main-tabs-tabItem"><img src="../assets/img/zeroCode/tab2.png" /></div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>提供可视化流程建模能力，支持业务流程快速绘制，提供常用的流程操作，如提交、驳回、加签、撤回等。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="third">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/zeroCodePhone/tab3.png"></div>
                数据表格
              </div>
              <div class="main-tabs-tabItem"><img src="../assets/img/zeroCode/tab3.png" /></div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>支持表单自动生成数据看板，支持用户在运行时自定义显示方案、 查询方案，进行数据导入导出等操作，为企业数据分析提供有效支撑。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="fourth">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/zeroCodePhone/tab4.png"></div>
                数据权限
              </div>
              <div class="main-tabs-tabItem"><img src="../assets/img/zeroCode/tab4.png" /></div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>提供开发权限、应用权限、表单权限等多维度多层次的数据权限控制体系。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="fourth">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/zeroCodePhone/tab5.png" /></div>
                仪表盘
              </div>
              <div class="main-tabs-tabItem"><img src="../assets/img/zeroCode/tab5.png" /></div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>包含数据流和数据集，数据流支持跨应用、跨表单取数据，支持数据筛选、数据汇总、分组合并、数据联查等功能，数据集支持跨表单取数据。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="fourth">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/zeroCodePhone/tab6.png" /></div>
                API连接
              </div>
              <div class="main-tabs-tabItem"><img src="../assets/img/zeroCode/tab1.png" /></div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>支持将已有后端服务(API)通过可视化配置的方式注册到平台上，也可通过图形化编排的方式组合已有API服务开放为新的APl，通过对API的多次组装形成组合应用，实现API的快速复制和创新，以及业务能力和数据的简单、快速、安全开放。</div>
                  </div>
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
        <!-- 快速构建轻应用 -->
        <div class="div-title" style="margin-bottom: 20px">快速构建轻应用</div>
        <div class="core-value">
          <div class="core-layout">
            <div class="core-content">
              <div class="core-item">
                <div>
                  <span class="value-title">内部系统/小型业务应用</span>
                  <div class="value-desc">全员皆可快速搭建内部应用，让专业开发人员专注于核心、复杂业务逻辑的实现，如：日报管理、订餐管理等。</div>
                  <img src="../assets/img/zeroCodePhone/core-item-1.png" />
                </div>
              </div>
              <div class="core-item">
                <div>
                  <span class="value-title">高度灵活、随需求而变的系统</span>
                  <div class="value-desc">面对业务需求灵活多变的情况，能够更快地交付，发布即可用，能够快速迭代，如：办公自动化系统等。</div>
                  <img src="../assets/img/zeroCodePhone/core-item-2.png" />
                </div>
              </div>
              <div class="core-item">
                <div>
                  <span class="value-title">数据填报收集</span>
                  <div class="value-desc">对于随机的、业务固化的、繁琐的、不确定的、经常变化的数据填报类的需求，可以快速响应，如：聚餐征集管理等。</div>
                  <img src="../assets/img/zeroCodePhone/core-item-3.png" style="top: -1.3rem"/>
                </div>
              </div>
              <div class="core-item">
                <div>
                  <span class="value-title" style="font-size: 13px">对现有业务功能的补充</span>
                  <div class="value-desc">以插件的形式集成到现有业务系统中，使其具备零代码开发能力，快速搭建应用，补充现有业务系统的功能不足。</div>
                  <img src="../assets/img/zeroCodePhone/core-item-4.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部公司信息 -->
        <CompanyInformation @changePracticeMenuShow="handleOpenPractice"></CompanyInformation>
      </div>
      <!-- 右侧菜单 -->
      <RightMenu :isMenuShow="isMenuShow" @rightMenuShow="handleRightMenuShow"></RightMenu>
      <!-- 底部立即体验弹出 -->
      <ExperienceNow :isPopShow="isPopShow" @CloseExperienceNow="handleCloseExperienceNow"></ExperienceNow>
    </div>
    <PhoneFooter @handleFooter="handleOpenPractice"></PhoneFooter>
  </div>
</template>

<script>
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import Swiper, { Navigation } from "swiper";
import PhoneHeader from "./include/PhoneHeader";
import PhoneFooter from "./include/PhoneFooter";
import RightMenu from "./include/RightMenu";
import CompanyInformation from "./include/CompanyInformation";
import ExperienceNow from "./include/ExperienceNow";
const function21 = require("../assets/img/homePage/function21.gif");
const function22 = require("../assets/img/homePage/function22.gif");
Swiper.use([Navigation]);
export default {
  name: "ZeroCodePhone",
  components: {
    PhoneFooter,
    PhoneHeader,
    CompanyInformation,
    RightMenu,
    ExperienceNow,
  },
  data() {
    return {
      isPopShow: false, // 立即体验弹窗
      isMenuShow: false, // 顶部菜单栏
      videoPlayDialogVisible: false, // 顶部视频播放弹窗
      modelActive: "formular", // tab页默认显示
      mainActive: "first", // tab页默认显示
      funcSrc: "function21", // 动图播放完毕后显示gif
    };
  },
  watch: {
    mainActive(n) {
      if (n === "second") {
        this.funcSrc = function21;
        setTimeout(() => {
          this.funcSrc = function22;
        }, 3000);
      }
    },
  },
  methods: {
    // 了解更多
    handleRouter() {
      this.$router.push("/CasePhonePage");
    },
    // 打开右侧菜单弹窗
    handleMenu() {
      this.isMenuShow = true;
    },
    // 关闭右侧菜单弹窗
    handleRightMenuShow() {
      this.isMenuShow = false;
    },
    // 打开立即体验弹窗
    handleOpenPractice() {
      this.isPopShow = true;
    },
    // 关闭立即体验弹窗
    handleCloseExperienceNow() {
      this.isPopShow = false;
    },
  },
  mounted() {},
};
</script>

<style scoped>
/* 头部 */
.banner-box {width: 100%;height: 391px;background: url("../assets/img/zeroCodePhone/banner-bg.png") no-repeat;background-size: 100%;margin-top: 52px;}
.banner-con {width: 100%;margin: 0 auto;padding-top: 20px;}
.banner-title {font-size: 23px;font-weight: bold;line-height: 50px;text-align: center;display: flex;justify-content: center;}
.banner-desc {display: flex;align-items: center;position: relative;font-size: 16px;font-weight: 400;justify-content: center;}
.app-button-div{width: 100%;text-align: center;margin-top: 190px}
.app-button-img{width: 120px;}

/*轻骑兵 零代码开发平台*/
.div-title {font-size: 22px;font-weight: bold;line-height: 50px;text-align: center;display: flex;justify-content: center;color: #2e2e2e;margin-top: 50px}
.div-desc {display: flex;align-items: center;position: relative;font-size: 14px;font-weight: 400;justify-content: center;color: #8E8E8E;margin-bottom: 30px}
.base-content-div{width: 92%;margin: 15px auto;box-shadow: 0px 0px 10px 1px rgba(0,46,154,0.15);border-radius: 5px 5px 5px 5px;display: flex}
.base-content-title{font-weight: bold;font-size: 16px;color: #014BE6;line-height: 31px; margin: 10px 0px 5px 15px;}
.base-content-desc{font-size: 13px;color: #2E2E2E;line-height: 22px;width: 230px; margin: 0px 0px 10px 15px;}
.base-content-div img{width: 125px;position: relative;left: -10px}

/* 轻骑兵 零代码开发平台 让您的想法更快地变为现实 */
.digitalize {width: 100%;}
.digitalize > img {width: 100%;margin-top: 20px;}
.digitalize-title {font-size: 25px;font-weight: bold;line-height: 30px;text-align: center;padding-top: 50px;padding-bottom: 25px;}
.digitalize-bg {text-align: center;padding: 0 18px 40px 18px;;}
.digitalize-bg > img {width: 100%;margin-bottom: 10px;}

/*轻骑兵 零代码开发平台 引领未来应用开发的新范式*/
.new-style{background: url("../assets/img/zeroCodePhone/new-style-bg.png") no-repeat;background-size: 100% 100%;padding-top: 1px;padding-bottom: 40px}
.new-style-div{display: flex;justify-content: center;}
.new-style-list{display: flex;justify-content: center;background: #FFFFFF;box-shadow: 0px 0px 4px 1px rgba(0,28,94,0.18);border-radius: 3px;opacity: 0.9;padding: 5px 10px 2px 10px;margin: 8px 5px;}
.new-style-list img{width: 50px;}
.new-style-title{padding: 10px 10px 10px 15px;line-height: 40px;font-weight: bold;color: #2e2e2e;font-size: 14px;width: 100px}

/* 主要功能 */
.main-method {overflow: hidden;}
.main-title {font-size: 25px;font-weight: bold;line-height: 30px;text-align: center;padding: 44px 0 24px 0;}
.main-tabs-tabItem {display: flex;margin: 20px 0 32px 0;justify-content: center;}
.main-tabs-tabItem > img {height: 200px;}
.main-tabs-tabItem-box {display: flex;justify-content: center;height: 100%;min-height: 100px;}
.main-tabs-tabItem-box > div {width: 90%;}
.main-tabs-tabItem-context-item {display: flex;margin-bottom: 30px;}
.main-tabs-tabItem-context-item > img {height: 20px;padding-right: 10px;}
.main-tabs-tabItem-context-item > div {font-size: 15px;line-height: 30px;}
van-tabs__wrap,
.van-tabs__wrap scroll-view,
.van-tabs__nav,
.van-tab {height: 130px!important;background-color: white;}

/* 快速构建轻应用 */
.core-value {background: #FFFFFF;}
.core-title {font-size: 25px;font-weight: bold;line-height: 30px;text-align: center;padding: 40px 0 30px 0;}
.core-layout {display: flex;padding-bottom: 30px;}
.core-content {width: 90%;margin: auto;color: #FFFFFF;}
.value-title {font-size: 16px;font-weight: bold;}
.value-desc {font-size: 13px;margin-top: 15px;line-height: 25px;color: #EEEEEE;}
.core-item {background: #3273F3;height: 150px;background-size: 100% 80px;margin-bottom: 20px;display: flex;padding: 20px 20px;border-radius: 3px;}
.core-item img{width: 55px;position: relative;left: 5.1rem;top: -1.1rem;}

/* 案例 */
.case {background: url("../assets/img/phoneHomePage/case-bg.png");height: 828px;}
.case-title {font-size: 25px;font-weight: bold;line-height: 56px;text-align: center;padding: 30px 0;color: white;}
.case-box {display: flex;justify-content: center;}
.case-swipe {height: 350px;}
.case-swipe >>> .van-swipe__indicators .van-swipe__indicator {background: #333333;}
.case-swipe >>> .van-swipe__indicator--active {background-color: #1989fa !important;}
.case-item {height: 100%;width: 90%;padding: 20px 20px 0 20px;background-image: linear-gradient(to bottom, #fff, #e9f0ff);border-radius: 5px;}
.van-swipe-item {display: flex;justify-content: center;}
.case-item > img {height: 55px;}
.case-item > .title {margin: 10px 0;font-size: 18px;font-weight: 600;}
.case-item > .text {font-size: 15px;font-weight: 400;line-height: 25px;}
.case-application-box {display: flex;justify-content: center;}
.case-application {width: 90%;height: 200px;padding: 20px;background: #203558;margin-top: 40px;}
.case-application .title {color: #fff;font-size: 18px;font-weight: bold;}
.case-application-items {display: flex;justify-content: space-between;}
.case-application-item > div {font-size: 15px;color: #fff;margin-bottom: 15px;}
.case > .btn {display: flex;justify-content: center;margin-top: 30px;}
</style>



// WEBPACK FOOTER //
// src/components/ZeroCodePhone.vue